import { League } from "sbtech-sports-data-api-contracts";

export const sortLeagues = (x: League, y: League) => x.defaultOrder - y.defaultOrder;